import styled from "styled-components";
import { variant } from "styled-system";
import propTypes from "@styled-system/prop-types";
import Box from "../Grid/Box";

const Link = styled(Box)(
  {
    cursor: "pointer",
    textDecoration: "none",
  },
  variant({
    variants: {
      smallBorderTop: {
        position: "relative",
        textTransform: "uppercase",
        fontWeight: "semiBold",
        fontSize: 0,
        textDecoration: "none",
        color: "linkSecondary",
        height: 30,
        display: "flex",
        alignItems: "flex-end",
        lineHeight: "10px",
        "&:after": {
          content: "''",
          position: "absolute",
          top: 0,
          left: 0,
          width: "15px",
          height: "1px",
          backgroundColor: "headlinesSecondary",
        },
        "&:hover": {
          color: "link",
          textDecoration: "none",
        },
        svg: {
          marginLeft: "6px",
          "& > *": {
            fill: "cta",
          },
        },
      },
      smallBorderBottom: {
        position: "relative",
        "&:after": {
          content: "''",
          position: "absolute",
          bottom: "0",
          left: "0",
          width: "15px",
          height: "1px",
          backgroundColor: "headlinesSecondary",
        },
        "&:hover": {
          h4: {
            textDecoration: "underline",
          },
        },
      },
      footerEmail: {
        fontWeight: "light",
        fontSize: 3,
        color: "footer.mail",
        "&:hover": {
          color: "white.100",
        },
      },
      regular: {
        "&, &:link, &:visited": {
          textDecoration: "none",
          color: "link",
        },
        "&:hover, &:active, &:focus": {
          color: "link",
          textDecoration: "underline",
        },
      },
      secondaryLink: {
        "&, &:link, &:visited": {
          textDecoration: "none",
          color: "linkSecondary",
        },
        "&:hover, &:active, &:focus": {
          color: "linkSecondary",
          textDecoration: "underline",
        },
      },
      underline: {
        textDecoration: "underline",
        "&:hover": {
          textDecoration: "none",
        },
      },
      noUnderline: {
        textDecoration: "none",
        "&:hover": {
          "h2, h3, h4": {
            textDecoration: "underline",
          },
        },
      },
      shadow: {
        boxShadow: "none",
        transition: "box-shadow 250ms ease-in-out",
        // minHeight: "-webkit-fill-available",
        "&:hover, &:active, &:visited": {
          color: "inherit",
          boxShadow: "one",
        },
      },
    },
  })
);

Link.displayName = "Link";

Link.defaultProps = {
  display: "inline-block",
  fontSize: 2,
  fontWeight: "normal",
};

Link.propTypes = {
  ...propTypes.space,
  ...propTypes.color,
  ...propTypes.layout,
  ...propTypes.typography,
  ...propTypes.position,
};

export { Link };
